import {modelHydrator} from "./_modelHydrator";
import {equipmentResultType} from "../../types/Api/EquipmentResultType";
import {equipment} from "../equipment";
import {sizeResultType} from "../../types/Api/SizeResultType";
import {sizeHydrator} from "./sizeHydrator";
import {collectionHydrator} from "./collectionHydrator";
import {bodyAreaHydrator} from "./bodyAreaHydrator";

export const equipmentHydrator = {
  hydrate: (equipment: equipmentResultType): equipment => {
    return Object.assign({
      equipmentId: equipment.equipmentId,
      label: equipment.label,
      price: equipment.price ?? undefined,
      picture: equipment.picture,
      collection: collectionHydrator.hydrate(equipment.collection),
      bodyArea: equipment.bodyArea ? bodyAreaHydrator.hydrate(equipment.bodyArea) : undefined,
      sizes: equipment.sizes?.map((r: sizeResultType) => sizeHydrator.hydrate(r)),
    }, modelHydrator.hydrate(equipment))
  }
}